// @flow
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Input,
  AutoComplete,
  Button,
  Notification,
} from "components/Atoms";
import { H6 } from 'components/CustomTypography';
import CustomFlexBox from 'components/CustomFlexBox';

import "./style.scss";
import * as Actions from "actions";
import * as ActionTypes from "constants/ActionTypes";

import AdminShopSupportTicket from "components/elements/admin/shops/AdminShopSupportTicket";
import AdminShopSupportTicketSettingEditor from "components/elements/admin/shops/AdminShopSupportTicketSettingEditor";

import MockProductList from "components/elements/main/MockProductList";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {Box, Container, Grid, IconButton, MenuItem} from "@mui/material";
import {useHistory} from "react-router";
import {
  checkUserAllowed,
  getAdminShopLogReasonList,
  getAdminShopLogStatusList,
  getAdminSupportTicketStatusList
} from "helpers/utils";
import SelectFieldComponent from "components/SelectField";
import ButtonComponent from "components/Button";
import DatePicker from "react-datepicker";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CustomSectionCreator from "components/CustomSectionCreator";
import {adminSearchShopSupportTicket, adminUpdateSalesLogStatus, adminUpdateSupportTicketStatusSuccess} from "actions";
import ShopHeaderBack from "components/elements/main/ShopHeaderBack";
import AdminProductSearch from "components/widgets/admin/AdminProductSearch";


const AdminSupportMain = (props) => {

  const [state, setState] = useState({
    limit: 5,
    hasMoreItems: true,
    breakPoint: "lg",
    bShowSearchModal: false,
  });

  const [saleslogModeState, setSaleLogModeState] = useState("PREVIEW");
  const [saleslogState, setSaleLogState] = useState("");
  const [filterState, setFilterState] = useState("");
  const [statusState, setStatusState] = useState("");
  const [executiveState, setExecutiveState] = useState("");
  const [startdateState, setStartdateState] = useState(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));
  const [offsetState, setOffsetState] = useState(0);

  const {
    serviceError, reqStatus, isLoading, bootupInfo, execList, userDetails,
    adminUpdateSupportTicketStatusSuccess, adminSearchShopSupportTicket, supporttickets,
    adminGetSalesExecutives
  } = props;

  useEffect(() => {
    adminSearchShopSupportTicket();
    adminGetSalesExecutives();
  }, []);

  const sendNotification = (type, { title, description = "" }) => {
    Notification[type]({
      message: title,
      description,
    });
  };

  useEffect(() => {
    if (serviceError && reqStatus) {
      const feedback = {
        title: serviceError,
        description: serviceError,
      };
      sendNotification("error", feedback);
    }
    switch (reqStatus) {
      case ActionTypes.ADMIN_UPDATE_STORE_SUPPORT_TICKET_SUCCESS:
        adminSearchShopSupportTicket(filterState, statusState, startdateState, executiveState, offsetState);
        break;
      default:
        break;
    }
  }, [serviceError, reqStatus]);

  const updateSaleLogStatusCall = (data) => {
    adminUpdateSupportTicketStatusSuccess(data);
    setSaleLogModeState("PREVIEW");
  };

  const handleCategoryEdit = (mode, item, reset) => (e) => {
    setSaleLogModeState(mode);
    if (reset) {
      setSaleLogState({
        selectedSaleLog: {
          name: "", description: "", _id: "", images: [], saleslog_id : "", title : "",
          is_saleslog_active: "", is_shop_active: "", shop_created_at: "", saleslog_created_at: "",
          domain: "", subdomain: "",
        },
      });
    } else {
      setSaleLogState({
        selectedSaleLog: {
          name: item.name, description: item.description, _id: item._id, images: item.images,
          saleslog_id : item.saleslog_id, title : item.title, is_saleslog_active: item.is_saleslog_active,
          is_shop_active: item.is_shop_active, shop_created_at: item.shop_created_at,
          saleslog_created_at: item.saleslog_created_at, domain: item.domain, subdomain: item.subdomain
        },
      });
    }
  };

  const handleCategorySetting = (mode, item) => (e) => {

    setSaleLogModeState(mode);

    setSaleLogState({
      selectedSaleLog: {
        _id: item._id,
        images: item.images,
        message: item.message,
        type: item.type,
        status: item.status,
        shop: item.shop,
        created_at: item.created_at,
      },
    });
  };

  const handleProductEdit = (mode, item) => (e) => {

    setSaleLogModeState(mode);

    setSaleLogState({
      selectedSaleLog: {
        _id: item._id,
        images: item.images,
        message: item.message,
        type: item.type,
        status: item.status,
        shop: item.shop,
        created_at: item.created_at,
      },
    });
  };

  const handleCategoryImage = (mode, item, reset) => (e) => {
    setSaleLogModeState(mode);
    if (reset) {
      setSaleLogState({
        selectedSaleLog: {
          name: "", description: "", _id: "", images: [], saleslog_id: "", title: "", shop: [],
          is_saleslog_active: "", is_shop_active: "", shop_created_at: "", saleslog_created_at: "",
          domain: "", subdomain: "",
        },
      });
    } else {
      setSaleLogState({
        selectedSaleLog: {
          name: item.name, description: item.description, _id: item._id, images: item.images,
          saleslog_id: item.saleslog_id, title: item.title, is_saleslog_active: item.is_saleslog_active,
          is_shop_active: item.is_shop_active, shop_created_at: item.shop_created_at,
          saleslog_created_at: item.saleslog_created_at, domain: item.domain, subdomain: item.subdomain
        },
      });
    }
  };

  const CustomDatePicker = React.forwardRef(({ value, onClick }, ref) => (
      <ButtonComponent
          type="primary"
          variant="contained"
          name={value}
          size="small"
          onClick={onClick} ref={ref}>
        {value}
      </ButtonComponent>
  ));

  const handleRestAll = (event) => {
    setFilterState("");
    setStatusState("");
    adminSearchShopSupportTicket("", "", "", 0);
  }

  const handlePrevOffset = () => {
    const offset = offsetState > 20 ? offsetState - 20 : 0;
    setOffsetState(offset);
    adminSearchShopSupportTicket(filterState, statusState, startdateState, executiveState, offset);
  }

  const handleNextOffset = () => {
    const offset = offsetState + 20;
    setOffsetState(offset);
    adminSearchShopSupportTicket(filterState, statusState, startdateState, executiveState, offset);
  }

  const handleSaleLogAddDate = (update) => {
    setStartdateState(update.getTime());
    adminSearchShopSupportTicket(filterState, statusState, update.getTime(), executiveState, offsetState);
  };

  const handleSaleLogFilter = (event) => {
    setFilterState(event.target.value);
    adminSearchShopSupportTicket(event.target.value, statusState, startdateState, executiveState, 0);
  };

  const handleSaleLogStatusFilter = (event) => {
    setStatusState(event.target.value);
    adminSearchShopSupportTicket(filterState, event.target.value, startdateState, executiveState, 0);
  };

  const handleSalesLeadExecutive = (event) => {
    setExecutiveState(event.target.value);
    setOffsetState(0);
    adminSearchShopSupportTicket("", statusState, startdateState, event.target.value, 0);
  }

  const saleslogfilter = getAdminShopLogReasonList();

  const inputSaleLogFilterOptions = saleslogfilter.map((item) => {
    const { value, label } = item;
    return (
        <MenuItem value={value}>{label}</MenuItem>
    );
  });

  const supportTicketStatusfilter = getAdminSupportTicketStatusList();

  const inputSaleLogStatusFilterOptions = supportTicketStatusfilter.map((item) => {
    const { value, label } = item;
    return (
        <MenuItem value={value}>{label}</MenuItem>
    );
  });


  const { executives } = execList;

  const inputExecutiveFilterOptions = executives.map((item) => {
    const { name, _id } = item;
    return (
        <MenuItem value={_id}>{name}</MenuItem>
    );
  });

  const history = useHistory();

  const handlePage = (page) => (e) => {
    history.push(page);
  };


  const { selectedSaleLog = {} } = saleslogState;

  const renderNoResults = () => (
      <section className="cart-section section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div>
                <div className="col-sm-12 empty-cart-cls text-center">
                  <H6>No saleslog found
                  </H6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );

  const renderSaleLogResults = () => (
    <div>
          {supporttickets.map((saleslog, index) => (
              <AdminShopSupportTicket
                className="product-item"
                key={saleslog.id}
                saleslog={saleslog}
                userDetails={bootupInfo.userDetails}
                isLoading={isLoading}
                editProducts={handleProductEdit("EDIT_PROD", saleslog)}
                editCategorySettings={handleCategorySetting("EDIT_SET", saleslog)}
              />
          ))}
    </div>
  );

  const renderSaleLogList = () => (
      <Container>
        <CustomFlexBox sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%'
        }}>
          <Box width="30%" align="center">
            <SelectFieldComponent
                required
                options={inputSaleLogFilterOptions}
                label="Type"
                value={filterState}
                onChange={(event) => handleSaleLogFilter(event)}
            />
          </Box>
          <Box width="30%" align="center">
            <SelectFieldComponent
                required
                options={inputSaleLogStatusFilterOptions}
                label="Status"
                value={statusState}
                onChange={(event) => handleSaleLogStatusFilter(event)}
            />
          </Box>
          <Box width="40%" align="center">
            <SelectFieldComponent
                sx={{margin: "4px"}}
                required
                options={inputExecutiveFilterOptions}
                label="Executive"
                value={executiveState}
                onChange={(event) => handleSalesLeadExecutive(event)}
            />
          </Box>
        </CustomFlexBox>
        <CustomFlexBox sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%'
        }}>
          <Box width="60%" align="center">
            Shops Before:
            <DatePicker
                placeholderText="Select Date"
                selected={startdateState}
                maxDate={new Date(new Date().getTime() + 24 * 60 * 60 * 1000)}
                onChange={handleSaleLogAddDate}
                dateFormat="MMMM d, yyyy"
                customInput={<CustomDatePicker />}
            />
          </Box>
          <Box width="20%" align="right">
            {offsetState > 0 && <IconButton onClick={handlePrevOffset}>
              <ArrowBackIosIcon fontSize="medium" color="primary"/>
            </IconButton>
            }
          </Box>
          <Box width="20%" align="right">
            <IconButton onClick={handleNextOffset}>
              <ArrowForwardIosIcon fontSize="medium" color="primary"/>
            </IconButton>

          </Box>
        </CustomFlexBox>
        <CustomSectionCreator isSubtle={true} title="Support Tickets" />
      {isLoading ? <MockProductList /> : supporttickets.length > 0 ? renderSaleLogResults() : renderNoResults()},

      </Container>
  );

  const renderCategoryEdit = () => {
    switch (saleslogModeState) {
      case "EDIT_PROD":
        return (
            <>
              <CustomSectionCreator isSubtle={true} title="Shop Products" />
              <ShopHeaderBack  {...props} onCancel={() => setSaleLogModeState("PREVIEW")} />
              {selectedSaleLog.shop &&
              <AdminProductSearch {...props}
                                  shopId={selectedSaleLog.shop._id}
                                  isShop={true}
              />}
            </>
        );

      case "EDIT_SET":
      default:
        return (
          <AdminShopSupportTicketSettingEditor
              {...props}
              setState={(value, field) => setSaleLogState({
                ...state,
                selectedSaleLog: {
                  ...selectedSaleLog,
                  [field]: value,
                },
              })}
            saleslog={selectedSaleLog}
              selectedSaleLog={selectedSaleLog}
              history={history}
              userDetails={bootupInfo.userDetails}
              updateSaleLogSettingClicked={updateSaleLogStatusCall}
              isLoading={isLoading}
              onCancel={() => setSaleLogModeState("PREVIEW")}
          />
        );
    }
  };

  return (
    <Container>
      {saleslogModeState === "PREVIEW" ? (
        renderSaleLogList()
      ) : (
        renderCategoryEdit(saleslogModeState)
      )}
    </Container>
  );
};

AdminSupportMain.defaultProps = {
  isLoading: false,
  serviceError: "",
  reqStatus: "",
  supporttickets: [],
};

AdminSupportMain.propTypes = {
  isLoading: PropTypes.bool,
  serviceError: PropTypes.string,
  reqStatus: PropTypes.string,
  searchsupporttickets: PropTypes.objectOf(PropTypes.any).isRequired,
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  adminSearchSaleLogs: PropTypes.func.isRequired,
  adminUpdateSaleLog: PropTypes.func.isRequired,
};

const adminSupportMain = connect(
  ({ adminShops, adminSales, bootupInfo }) => ({
    bootupInfo,
    userDetails: bootupInfo.userDetails,
    reqStatus: adminShops.reqStatus,
    isLoading: adminShops.isLoading,
    serviceError: adminShops.serviceError,
    supporttickets: adminShops.searchsupporttickets,
    execList: adminSales.execList,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(AdminSupportMain);

export default adminSupportMain;
